import { createSlice } from "@reduxjs/toolkit";

export const translationClientSlice = createSlice({
  name: "translation-client",
  initialState: {
    isLoading: false,
    isError: false,
    translationClientData: [],
    message: "",
  },
  reducers: {
    onGetTranslationClient: (state) => {
      return {
        ...state,
        isGetLoading: true,
        translationClientData: [],
      };
    },

    onGetTranslationClientSuccess: (state, { payload }) => {
      const { getData = [], message = "", status_code = "200" } = payload;
      return {
        ...state,
        isGetLoading: false,
        translationClientData: getData,
        getMessage: message,
        get_status_code: status_code,
      };
    },

    onGetTranslationClientError: (state, { payload }) => {
      const { getData = [], message = "", status_code = 400 } = payload;
      return {
        ...state,
        translationClientData: getData,
        getMessage: message,
        get_status_code: status_code,
        isGetLoading: false,
      };
    },
    onGeTranslationClientReset: (state) => {
      return {
        ...state,
        translationClientData: [],
        getMessage: "",
        get_status_code: null,
        isGetLoading: false,
      };
    },
  },
});

export const {
  onGeTranslationClientReset,
  onGetTranslationClientSuccess,
  onGetTranslationClientError,
  onGetTranslationClient,
} = translationClientSlice.actions;

export default translationClientSlice.reducer;
